import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';

import { Icon, Image, Message, Popup } from 'semantic-ui-react';

import * as common from 'libs/commonFunc';

import classNames from 'classnames/bind';
import styles from './StartExam.css';
const cx = classNames.bind(styles);

class StartExamLicenseMessage extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;

    // 라이센스 결과
    let licenseContent;
    const { licenseResult, step } = this.props;
    const licenseResultData = {
      // 양호한 라이센스
      valid: [],
      // 라이센스 없음
      invalid: []
    };
    if (!licenseResult.isValidLicense) {
      const licenseTypeText = {
        1: '(' + defineMessages(formatMessage({ id: 'LicenseEdit_24', defaultMessage: '영구 라이센스' })) + ')',
        2: '(' + defineMessages(formatMessage({ id: 'LicenseEdit_25', defaultMessage: '기간 라이센스' })) + ')',
        4: '(' + defineMessages(formatMessage({ id: 'LicenseEdit_26', defaultMessage: '횟수 라이센스' })) + ')'
      };

      // step3 라이센스 에러
      // 라이센스 없을때
      const noLicense = step === 3 && licenseResult.error && licenseResult.error === 'noLicense' ? true : false;
      const noReserve = step === 3 && licenseResult.error && licenseResult.error === 'noReserve' ? true : false;
      // 기간 또는 횟수 라이센스
      const isTypeErrorStep3 = step === 3 && licenseResult.isValidLicense === 0 ? true : false;
      // step4 라이센스 에러(횟수 라이센스)
      const isTypeErrorStep4 = step === 4 && licenseResult.isValidLicense === 0 ? true : false;
      let periodCnt = 0;
      let timesCnt = 0;

      if (!!licenseResult && licenseResult.list && licenseResult.list.length > 0) {
        for (let i = 0, l = licenseResult.list.length; i < l; i++) {
          const dd = licenseResult.list[i];
          if (dd.licenseType === 1 || dd.licenseType === 2) {
            periodCnt += 1;
          }
          if (dd.licenseType === 4) {
            timesCnt += 1;
          }
          if (!!isTypeErrorStep3) {
            licenseResultData.invalid.push(
              <div>
                {/* 기간 */}
                {(dd.licenseType === 1 || dd.licenseType === 2) && (
                  <div className={cx('licensePeriod')}>
                    {periodCnt === 1 && (
                      <div className={cx('license-name')}>
                        ·{' '}
                        {defineMessages(formatMessage({ id: 'LicenseEdit_25', defaultMessage: '기간 라이센스' })) + ' '}
                        {licenseResult.periodCnt > 0 && (
                          <b>
                            {'(' +
                              licenseResult.periodCnt +
                              defineMessages(formatMessage({ id: 'LicenseList_6', defaultMessage: '명' })) +
                              ' ' +
                              defineMessages(formatMessage({ id: 'LicenseList_29', defaultMessage: '부족' })) +
                              ')'}
                          </b>
                        )}
                      </div>
                    )}
                    <div className={cx('licenseRow')}>
                      <div className={cx('license-number')}>#{dd.licenseNo}</div>
                      <div className={cx('license-target')}>
                        {dd.licenseCount - dd.remainCount} /{' '}
                        {dd.licenseCount + defineMessages(formatMessage({ id: 'LicenseList_6', defaultMessage: '명' }))}
                      </div>
                      <div>
                        {common.timeFormatFromUTCEpoch(dd.startEpoch, 3) +
                          '~' +
                          common.timeFormatFromUTCEpoch(dd.endEpoch, 3)}
                      </div>
                    </div>
                  </div>
                )}
                {/* 횟수 */}
                {dd.licenseType === 4 && (
                  <div className={cx('licenseTimes')}>
                    {timesCnt === 1 && (
                      <div className={cx('license-name')}>
                        ·{' '}
                        {defineMessages(formatMessage({ id: 'LicenseEdit_26', defaultMessage: '횟수 라이센스' })) + ' '}
                        {licenseResult.timesCnt > 0 && (
                          <b>
                            {'(' +
                              licenseResult.timesCnt +
                              defineMessages(formatMessage({ id: 'LicenseList_6', defaultMessage: '명' })) +
                              ' ' +
                              defineMessages(formatMessage({ id: 'LicenseList_29', defaultMessage: '부족' })) +
                              ')'}
                          </b>
                        )}
                      </div>
                    )}
                    <div className={cx('licenseRow')}>
                      <div className={cx('license-number')}>#{dd.licenseNo}</div>
                      <div className={cx('license-target')}>
                        {dd.licenseCount + defineMessages(formatMessage({ id: 'LicenseList_6', defaultMessage: '명' }))}
                      </div>
                      <div className={cx('')}>
                        {dd.examLimitCount -
                          dd.remainCount +
                          ' / ' +
                          dd.examLimitCount +
                          defineMessages(formatMessage({ id: 'StartExamWizardContent_107', defaultMessage: '회' }))}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            );
          } else if (!!isTypeErrorStep4) {
            licenseResultData.invalid.push(
              <div className={cx('licenseRow')}>
                {/* <Image src={'/img/examStart/ico_pop_x.png'} /> */}
                <div className={cx('license-number')}>#{dd.licenseNo}</div>
                <div className={cx('license-target')}>
                  {dd.licenseCount + defineMessages(formatMessage({ id: 'LicenseList_6', defaultMessage: '명' }))}
                </div>
                <div className={cx('license-count')}>
                  {dd.examLimitCount -
                    dd.remainCount +
                    ' / ' +
                    dd.examLimitCount +
                    defineMessages(formatMessage({ id: 'StartExamWizardContent_107', defaultMessage: '회' }))}{' '}
                  <b>
                    ({defineMessages(formatMessage({ id: 'StartExamWizardContent_113', defaultMessage: '남은 횟수' }))}:{' '}
                    {dd.remainCount +
                      defineMessages(formatMessage({ id: 'StartExamWizardContent_107', defaultMessage: '회' }))})
                  </b>
                </div>
              </div>
            );
          }
        }
      }

      if (licenseResultData.invalid.length > 0 || !!noLicense || !!noReserve) {
        licenseContent = (
          <div className={cx('license-error-message')}>
            {step === 3 && (
              <div className={cx('license-error-message')}>
                <Image src={'/img/examStart/ico_fail_s.png'} />
                {defineMessages(
                  formatMessage({
                    id: 'StartExamWizardContent_79',
                    defaultMessage: '선택한 대상자의 라이센스가 필요합니다.'
                  })
                )}
              </div>
            )}
            <div className={cx('startExam-licenseError-area')}>
              <div className={cx('startExam-licenseError-title')}>
                {defineMessages(
                  formatMessage({
                    id: 'StartExamWizardContent_101',
                    defaultMessage: '라이센스 현황'
                  })
                )}
              </div>
              <div className={cx('startExam-licenseError-content')}>
                {step === 3 &&
                  noLicense &&
                  defineMessages(
                    formatMessage({ id: 'LicenseList_26', defaultMessage: '라이센스가 존재하지 않습니다.' })
                  )}
                {step === 3 &&
                  noReserve &&
                  defineMessages(
                    formatMessage({
                      id: 'LicenseList_31',
                      defaultMessage: '훈련 시작일을 라이센스 유효기간 이후로 예약할 수 없습니다.'
                    })
                  )}
                {step === 3 &&
                  !noReserve &&
                  isTypeErrorStep3 &&
                  defineMessages(
                    formatMessage({ id: 'LicenseList_27', defaultMessage: '라이센스의 수량이 부족합니다.' })
                  )}
                {step === 4 &&
                  isTypeErrorStep4 &&
                  defineMessages(
                    formatMessage({ id: 'LicenseList_28', defaultMessage: '라이센스의 남은 횟수가 부족합니다.' })
                  )}
                {!noLicense && (
                    <div className={cx('startExam-licenseError-Detail')}>
                      {licenseResultData.invalid.map((data, index) => <div key={index}>{data}</div>)}
                    </div>
                  )}
              </div>
            </div>
          </div>
        );
      } else {
        licenseContent = (
          <div className={cx('licenseError ui error message')}>
            {defineMessages(formatMessage({ id: 'StartExamWizardContent_80', defaultMessage: '라이센스 에러' }))}
          </div>
        );
      }
    }

    return licenseContent;
  }
}

export default injectIntl(StartExamLicenseMessage);



// WEBPACK FOOTER //
// ./src/script/components/exam-start/StartExamLicenseMessage.js